/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */

import { DictationMicIcon } from '@heidi/dictate';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { Extension } from '@tiptap/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

interface DictationCursorStorage {
  shouldShowDuringRecording: boolean;
  position: number | null;
  active: boolean;
}

interface DictationCursorMeta {
  shouldShowDuringRecording?: boolean;
  position?: number;
  active?: boolean;
}

declare module '@tiptap/react' {
  interface Commands<ReturnType> {
    dictationCursor: {
      updateCursorPosition: (position: number | null) => ReturnType;
      showDictationCursor: (position: number) => ReturnType;
      hideDictationCursor: () => ReturnType;
    };
  }
}

export const DictationCursor = Extension.create<
  Record<string, never>,
  DictationCursorStorage
>({
  name: 'dictationCursor',

  addStorage() {
    return {
      shouldShowDuringRecording: true,
      position: null,
      active: false,
    };
  },

  addCommands() {
    return {
      updateCursorPosition:
        (position: number | null) =>
        ({ tr, dispatch }) => {
          if (dispatch) {
            this.storage.position = position;
            this.storage.active = true;
            tr.setMeta('dictationCursorPlugin', { position } as DictationCursorMeta);
          }
          return true;
        },

      showDictationCursor:
        (position: number) =>
        ({ tr, dispatch }) => {
          if (dispatch) {
            this.storage.active = true;
            this.storage.position = position;
            tr.setMeta('dictationCursorPlugin', {
              position,
              active: true,
            } as DictationCursorMeta);
          }
          return true;
        },

      hideDictationCursor:
        () =>
        ({ tr, dispatch }) => {
          if (dispatch) {
            this.storage.active = false;
            tr.setMeta('dictationCursorPlugin', { active: false } as DictationCursorMeta);
          }
          return true;
        },
    };
  },

  addProseMirrorPlugins() {
    const pluginKey = new PluginKey<DecorationSet>('dictationCursor');
    const editor = this.editor;
    return [
      new Plugin({
        key: pluginKey,
        state: {
          init() {
            return DecorationSet.empty;
          },
          apply(tr, oldState) {
            const meta = tr.getMeta('dictationCursorPlugin') as
              | DictationCursorMeta
              | undefined;
            // hide when not active

            if (editor.storage.dictation.isDictating === false) {
              return DecorationSet.empty;
            }

            if (editor.storage.dictationCursor.shouldShowDuringRecording === false) {
              return DecorationSet.empty;
            }

            if (editor.storage.dictationCursor.active === false) {
              return DecorationSet.empty;
            }

            const cursorPosition = meta?.position || tr.selection.from;

            // if (!meta) {
            //   return oldState.map(tr.mapping, tr.doc);
            // }

            // if (meta.active === false) {
            //   return DecorationSet.empty;
            // }

            if (cursorPosition === undefined) {
              return DecorationSet.empty;
            }

            if (cursorPosition !== undefined) {
              const position = cursorPosition;

              const cursor = Decoration.widget(
                position,
                () => {
                  const cursorElement = document.createElement('span');
                  cursorElement.classList.add('dictation-cursor');
                  cursorElement.setAttribute('style', 'position: relative; z-index: 10;');

                  const uniqueId = `dictation-mic-filter-${Math.random()
                    .toString(36)
                    .substring(2, 9)}`;

                  const iconContainer = document.createElement('div');
                  iconContainer.setAttribute(
                    'style',
                    'position: absolute; bottom: -30px; right: -24px;'
                  );

                  const iconRoot = createRoot(iconContainer);
                  iconRoot.render(
                    React.createElement(DictationMicIcon, { uniqueId: uniqueId })
                  );

                  const gifContainer = document.createElement('div');
                  gifContainer.setAttribute(
                    'style',
                    'position: absolute; top: 50%; left: 12px; transform: translateX(-50%) translateY(-50%); display: flex; gap: 1.2px; align-items: center;'
                  );

                  for (let i = 0; i < 3; i++) {
                    const dotElement = document.createElement('div');
                    dotElement.setAttribute(
                      'style',
                      `width: 4px; height: 4px; background-color: ${
                        !editor.storage.dictation.isLocked
                          ? 'transparent !important'
                          : 'grey'
                      }; border-radius: 50%; animation: typingDots 2.5s infinite ease-in-out ${
                        i * 0.3
                      }s;`
                    );
                    gifContainer.appendChild(dotElement);
                  }

                  // if (editor.storage.dictation.isLocked) {
                  cursorElement.appendChild(gifContainer);
                  // } else {
                  //   const placeholderElement = document.createElement('div');
                  //   placeholderElement.setAttribute('style', 'width: 12px; height: 4px');
                  //   cursorElement.appendChild(placeholderElement);
                  // }
                  cursorElement.appendChild(iconContainer);

                  return cursorElement;
                },
                { key: 'dictation-cursor' }
              );
              return DecorationSet.create(tr.doc, [cursor]);
            }

            return oldState.map(tr.mapping, tr.doc);
          },
        },
        props: {
          decorations(state) {
            return this.getState(state);
          },
        },
      }),
    ];
  },
});
